import React from 'react';
import { canAccessQCModule } from '../../utils/roleConstants';
import { Form, FormGroup, FormControl, Button, Modal, Row, Col } from 'react-bootstrap';
import config from '../../../config';
import { Navigate } from 'react-router';
import UploadFiles from "../../_components/upload-files.component";
import UploadService from "../../_services/upload-files.service";
import {Link} from 'react-router-dom';
import moment from 'moment';
import utils from '../../utils';
import Select from 'react-select';
import { MaterialReactTable } from "material-react-table";
import Paper from '@mui/material/Paper';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import MasterPartNoInput from '../../_components/MasterPartNoInput';
import { isPartNoCreateEnabled, MASTER_PART_NO_VALIDATION_STATUS } from '../../utils/masterPartNoValidation';
import { deleteMeasuringRow, updateMeasuringRow } from '../../utils/measuringRows';
import QValuePageHeader from '../../_components/QValuePageHeader';
import { getQValueMasterFormHeader } from '../../utils/qValuePageHeaders';

let perPage = 30;

class FaiMasterForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: 0,
            saving: false,
            partNo: '',
            partNoValidationStatus: MASTER_PART_NO_VALIDATION_STATUS.IDLE,
            partDesc: '',
            customerPartNo: '',
            category: '',
            customer: '',
            model: '',
            AQL: '',
            dwgVersion: '',
            files: [],
            company: 0,
            tabvalue: 0,
            selectedInspections: [],
            selectedTests: [],
            selectedMeasurings: [],
            masterCategory: 6,
            inspections: [
                { 'label': 'PCB/PCBA', 'specification': '', 'remark': '', 'requirement': 'PCB/PCBA' },
                { 'label': 'LED', 'specification': '', 'remark': '', 'requirement': 'LED' },
                { 'label': 'Wire', 'specification': '', 'remark': '', 'requirement': 'Wire' },
                { 'label': 'Glue', 'specification': '', 'remark': '', 'requirement': 'Glue' },
                { 'label': 'Soldering Position', 'specification': '', 'remark': '', 'requirement': 'Soldering Position' },
                { 'label': 'Terminal and Position', 'specification': '', 'remark': '', 'requirement': 'Terminal and Position' },
                { 'label': 'Installation Position', 'specification': '', 'remark': '', 'requirement': 'Installation Position' },
                { 'label': 'No Forget Install', 'specification': '', 'remark': '', 'requirement': 'No Forget Install' },
                { 'label': 'No Wrong position', 'specification': '', 'remark': '', 'requirement': 'No Wrong position' },
                { 'label': 'No Damage & Broken', 'specification': '', 'remark': '', 'requirement': 'No Oxidation' },
                { 'label': 'No Oxidation', 'specification': '', 'remark': '', 'requirement': 'No Oxidation' },
                { 'label': 'Safety Mark', 'specification': '', 'remark': '', 'requirement': 'Safety Mark' },
                { 'label': 'No Mix', 'specification': '', 'remark': '', 'requirement': 'No Mix' },
                { 'label': 'No Short Mould', 'specification': '', 'remark': '', 'requirement': 'No Short Mould' },
                { 'label': 'No Over Mould', 'specification': '', 'remark': '', 'requirement': 'No Over Mould' },
                { 'label': 'No Burr', 'specification': '', 'remark': '', 'requirement': 'No Burr' },
                { 'label': 'Wire PVC', 'specification': '', 'remark': '', 'requirement': 'Wire PVC' },
                { 'label': 'Wire Core', 'specification': '', 'remark': '', 'requirement': 'Wire Core' },
                { 'label': 'Material Part', 'specification': '', 'remark': '', 'requirement': 'Material Part' },
                { 'label': 'Terminal', 'specification': '', 'remark': '', 'requirement': 'Terminal' },
                { 'label': 'Match With Sample', 'specification': '', 'remark': '', 'requirement': 'Match With Sample' },
                { 'label': 'Production Check List', 'specification': '', 'remark': '', 'requirement': 'Production Check List' },
                { 'label': 'Check SOP and Actual', 'specification': '', 'remark': '', 'requirement': 'Check SOP and Actual' },
                { 'label': 'Operator', 'specification': '', 'remark': '', 'requirement': 'Operator' },
                { 'label': 'Maintainence Record', 'specification': '', 'remark': '', 'requirement': 'Maintainence Record' },
                { 'label': 'Repair Record', 'specification': '', 'remark': '', 'requirement': 'Repair Record' },
                { 'label': 'HSF Verify', 'specification': '', 'remark': '', 'requirement': 'HSF Verify' },
                { 'label': 'Others', 'specification': '', 'remark': '', 'requirement': 'Others' }
            ],
            // Material React Table column definitions (TanStack Table v8)
            inspectionsColumn: [
                { header: "Requirement", accessorKey: "requirement", enableEditing: false },
                { header: "Spec", accessorKey: "specification" },
                { header: "Content", accessorKey: "content" },
                { header: "Description", accessorKey: "remark" },
            ],
            testColumn: [
                { header: "Requirement", accessorKey: "requirement", enableEditing: false },
                { header: "Equipment", accessorKey: "equipment" },
                { header: "Spec", accessorKey: "specification" },
                { header: "No of Point", accessorKey: "noOfPoint" },
                { header: "Upper Limit", accessorKey: "upperLimit" },
                { header: "Lower Limit", accessorKey: "lowerLimit" },
                { header: "Description", accessorKey: "remark" },
            ],
            tests: [
                { 'label': 'Tension Force', 'specification': '', 'equipment':'', 'remark': '', 'requirement': 'TensionForce' },
                { 'label': 'Hit Pot', 'specification': '','equipment':'', 'remark': '', 'requirement': 'HitPot' },
                { 'label': 'Hardness', 'specification': '','equipment':'', 'remark': '', 'requirement': 'Hardness' },
                { 'label': 'MI', 'specification': '','equipment':'', 'remark': '', 'requirement': 'MI' },
                { 'label': 'Color', 'specification': '','equipment':'', 'remark': '', 'requirement': 'Color' },
                { 'label': 'Contact Resistant', 'specification': '','equipment':'', 'remark': '', 'requirement': 'ContactResistant' },
                { 'label': 'Terminal Blending', 'specification': '','equipment':'', 'remark': '', 'requirement': 'TerminalBlending' },
                { 'label': 'Salt Spray', 'specification': '', 'remark': '','equipment':'', 'requirement': 'SaltSpray' },
                { 'label': 'Thickness', 'specification': '', 'remark': '','equipment':'', 'requirement': 'Thickness' },
                { 'label': 'Soldering', 'specification': '', 'remark': '','equipment':'', 'requirement': 'Soldering' },
                { 'label': 'Load', 'specification': '', 'remark': '','equipment':'', 'requirement': 'Load' },
                { 'label': 'Adhesion', 'specification': '', 'remark': '','equipment':'', 'requirement': 'Adhesion' },
                { 'label': 'RoHS', 'specification': '', 'remark': '','equipment':'', 'requirement': 'RoHS' },
                { 'label': 'Others', 'specification': '', 'remark': '','equipment':'', 'requirement': 'Others' }
            ],
            measuringColumn: [
                { header: "Point to Measure", accessorKey: "pointToMeasure" },
                { header: "Equipment", accessorKey: "equipment" },
                { header: "Dimension", accessorKey: "Dimension" },
                { header: "UCL", accessorKey: "UCL" },
                { header: "LCL", accessorKey: "LCL" },
            ],
        }
        // Synchronous guard against double submission; state updates alone
        // leave a window where a second click can start another request.
        this.saveInProgress = false;
    }

    componentWillMount() {
        // Extract id from URL hash for React Router v6
        const hash = window.location.hash;
        const match = hash.match(/\/fai_master\/([^\/\?]+)/);
        const id = match ? match[1] : null;
        
        if (id && id !== 'new') {
            this.setState({ newMode: false });
        } else {
            this.setState({ newMode: true });
        }

        this.setState({
            processes: []
        });
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
        };
        if (localStorage.getItem('user') != null) {
            fetch(`${config.apiUrl}/getInspectionList?company=${JSON.parse(localStorage.getItem('user')).accountId}`, requestOptions)
                .then((response) => {
                    return response.text().then(text => {
                        const data = text && JSON.parse(text);

                        return data;
                    });
                })
                .then(requirements => {
                    let data = [];
                    // login successful if there's a user in the response
                    if (requirements && requirements.length) {
                        requirements.map(item => {
                            data.push(item)
                            this.setState({ inspections: data });

                        });
                    }
                });

            fetch(`${config.apiUrl}/getTestList?company=${JSON.parse(localStorage.getItem('user')).accountId}`, requestOptions)
                .then((response) => {
                    return response.text().then(text => {
                        const data = text && JSON.parse(text);

                        return data;
                    });
                })
                .then(tests => {
                    let data = [];
                    // login successful if there's a user in the response
                    if (tests && tests.length) {
                        tests.map(item => {
                            data.push(item)
                            this.setState({ tests: data });

                        });
                    }
                });
        }
        // Only fetch data if id exists and is not 'new'
        if (id && id !== 'new') {
            this.fetchData(id);
        }
    }

    exportExcel() {
        utils.tableToExcel('datatable', 'masterdata', 'FAI_Inspection_Master_' + moment().format('YYYYMMDD') + '.xls');
    };

    removeFile(index){
             let newfiles = [...this.state.files];
             newfiles[index]['mode'] ='remove';
             this.setState({ files: newfiles });
    }

    fetchData(id) {
        if (!id || id === 'new') {
            return Promise.resolve();
        }
        
        const { tableStyle, tableHeader } = this.state;
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
        };

        return fetch(`${config.apiUrl}/getOneFaiMaster?id=${id}`, requestOptions)
            .then((response) => {
                return response.text().then(text => {
                    const data = text && JSON.parse(text);

                    return data;
                });
            })
            .then(body => {
                // Preserve column definitions and ensure arrays are initialized
                // Don't let body overwrite column definitions from constructor
                const preservedColumns = {
                    inspectionsColumn: this.state.inspectionsColumn || [
                        { header: "Requirement", accessorKey: "requirement", enableEditing: false },
                        { header: "Spec", accessorKey: "specification" },
                        { header: "Content", accessorKey: "content" },
                        { header: "Description", accessorKey: "remark" },
                    ],
                    testColumn: this.state.testColumn || [
                        { header: "Requirement", accessorKey: "requirement", enableEditing: false },
                        { header: "Equipment", accessorKey: "equipment" },
                        { header: "Spec", accessorKey: "specification" },
                        { header: "No of Point", accessorKey: "noOfPoint" },
                        { header: "Upper Limit", accessorKey: "upperLimit" },
                        { header: "Lower Limit", accessorKey: "lowerLimit" },
                        { header: "Description", accessorKey: "remark" },
                    ],
                    measuringColumn: this.state.measuringColumn || [
                        { header: "Point to Measure", accessorKey: "pointToMeasure" },
                        { header: "Equipment", accessorKey: "equipment" },
                        { header: "Dimension", accessorKey: "Dimension" },
                        { header: "UCL", accessorKey: "UCL" },
                        { header: "LCL", accessorKey: "LCL" },
                    ],
                };
                
                // Ensure arrays are always arrays, never null or undefined
                const selectedInspections = Array.isArray(body.selectedInspections) ? body.selectedInspections : 
                                          (Array.isArray(body.inspections) ? body.inspections : []);
                const selectedTests = Array.isArray(body.selectedTests) ? body.selectedTests : 
                                    (Array.isArray(body.tests) ? body.tests : []);
                const selectedMeasurings = Array.isArray(body.selectedMeasurings) ? body.selectedMeasurings : 
                                         (Array.isArray(body.measurings) ? body.measurings : []);
                const files = Array.isArray(body.files) ? body.files : [];
                
                this.setState({
                    ...body,
                    ...preservedColumns, // Always preserve column definitions
                    // Override with validated arrays (these come after spread, so they override any null values)
                    selectedInspections: selectedInspections,
                    selectedTests: selectedTests,
                    selectedMeasurings: selectedMeasurings,
                    files: files,
                });
            })
            .catch((e) => {
            });;
    }


    selectedInspectionClicked(optionsList) {
        if (!optionsList) return;

        // Use functional setState to ensure we get the latest state
        this.setState(prevState => {
            // Ensure selectedInspections is always an array before spreading
            const currentInspections = Array.isArray(prevState.selectedInspections) ? prevState.selectedInspections : [];
            // Create new item: remove 'id' (inspection list ID) and set masterCategory and masterID
            // The backend will create a new record if 'id' is not present
            const { id, ...itemWithoutId } = optionsList;
            const newItem = { 
                ...itemWithoutId, 
                masterCategory: 6,
                masterID: prevState.id || null  // Link to the current master record
            };
            const newInspections = [...currentInspections, newItem];
            return {
                selectedInspections: newInspections
            };
        });
    }

    addNewMeasuring() {
        this.setState({
            selectedMeasurings: [...this.state.selectedMeasurings, { pointToMeasure: '', equipment: '', Dimension: '', UCL: '', LCL: '' }]
        })
    }

    selectedTestClicked(optionsList) {
        if (!optionsList) return;
        
        // Use functional setState to ensure we get the latest state
        this.setState(prevState => {
            // Ensure selectedTests is always an array before spreading
            const currentTests = Array.isArray(prevState.selectedTests) ? prevState.selectedTests : [];
            // Create new item: remove 'id' (test list ID) and set masterCategory and masterID
            // The backend will create a new record if 'id' is not present
            const { id, ...itemWithoutId } = optionsList;
            const newItem = { 
                ...itemWithoutId, 
                masterCategory: 6,
                masterID: prevState.id || null  // Link to the current master record
            };
            return {
                selectedTests: [...currentTests, newItem]
            };
        });
    }

    selectedMeasuringClicked(optionsList) {
        
        this.setState({ selectedMeasurings: optionsList });
    }

    handleChange(event, newValue) {
        this.setState({ tabvalue: newValue });
    }

    handleClose() {
        window.location.hash = '#/fai_master';
    }

    handlePartNoValidationChange = (partNoValidationStatus) => {
        this.setState({ partNoValidationStatus });
    };

    handlePartDataMatch = (part) => {
        this.setState({
            customerPartNo: part && part.customerPartNo ? part.customerPartNo : '',
        });
    };

    uploadImage(event){
        UploadService.uploadImage(event.target.files, (event) => {

          })
            .then((response) => {
                let existingFiles = [...this.state.files];
                if(response.data)
                response.data.map(item=>{
                    item.imgPath=  'img/'+item.filename;
                    return item;
                })
              existingFiles = [...existingFiles, ...response.data];

              this.setState({
                files:  existingFiles,
                message: "Uploaded",
              });
            })

            .catch(() => {
              this.setState({
                message: "Could not upload the image!",
                currentFile: undefined,
              });
            });
    }

    handleSave() {
        // New rows carry no id, so every extra request while one is still
        // running re-creates them on the backend as duplicate records.
        if (this.saveInProgress) return;

        let { id, partNo, partDesc, customerPartNo, AQL, customer, model, dwgVersion, category, files, selectedInspections, selectedTests, selectedMeasurings } = this.state;

        // Send all items including those marked for removal so backend can process deletions
        // Items with mode: 'remove' will be deleted by the backend
        const inspectionsToSave = selectedInspections || [];
        const testsToSave = selectedTests || [];
        const measuringsToSave = selectedMeasurings || [];

        if (!window.confirm("Are you sure you update this data?")) return;

        this.saveInProgress = true;
        this.setState({ saving: true });

        // A per-attempt key lets the backend recognise network-level replays
        // of this exact request and process it only once.
        const saveRequestId = (window.crypto && window.crypto.randomUUID)
            ? window.crypto.randomUUID()
            : Date.now() + '-' + Math.random().toString(16).slice(2);

        fetch(`${config.apiUrl}/updateFaiMaster`, {
            method: "post",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },

            //make sure to serialize your JSON body
            body: JSON.stringify({
                partNo,
                partDesc,
                customerPartNo,
                category,
                customer,
                model,
                AQL,
                dwgVersion,
                files,
                inspections: inspectionsToSave,
                tests: testsToSave,
                measurings: measuringsToSave,
                masterCategory: 6,
                id,
                saveRequestId,
                company: JSON.parse(localStorage.getItem('user')).accountId,
            })
        })
            .then((response) => {
                if (response.status == 200) {
                    window.alert('Update Successfully.');

                    this.handleClose();
                    this.fetchData();
                } else {
                    console.error('Failed to save FAI master, status:', response.status);
                    this.saveInProgress = false;
                    this.setState({ saving: false });
                }
            })
            .catch((error) => {
                console.error('Failed to save FAI master:', error);
                this.saveInProgress = false;
                this.setState({ saving: false });
            });

    }

    render() {
        const user = JSON.parse(localStorage.getItem('user'));
        if (!canAccessQCModule(user)) {
            return <Navigate to='/' />
        }
        let { keyword, newMode, products, partNo,
            partDesc,
            customerPartNo,
            category,
            customer,
            model,
            AQL,
            dwgVersion, files } = this.state;

        return (
            <div class="container">
                <QValuePageHeader
                    {...getQValueMasterFormHeader('fai_master', {
                        isNew: newMode,
                        partNo,
                    })}
                />
                <div>
                    <Form>
                        <FormGroup className="row" as={Row} controlId="formImage"  style={{marginBottom:'35px'}}>
                        {files.length>0 &&<Col sm={6} style={{border: '1px solid #ccc'}}>
                        <ul class='file-list'>
                        {
                                    files.map((img,i) => {
                                        if(!img.mode || img.mode !='remove')
                                        return <li key={ i } style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '5px 0' }}>
                                            <a href={img.imgPath} target="_blank" style={{ flex: 1, marginRight: '10px' }}>{img.originalname}</a>
                                            <button 
                                                type="button"
                                                style={{ 
                                                    backgroundColor: '#dc3545', 
                                                    color: 'white', 
                                                    border: 'none', 
                                                    borderRadius: '3px', 
                                                    padding: '5px 10px', 
                                                    cursor: 'pointer',
                                                    fontSize: '12px'
                                                }}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    this.removeFile(i);
                                                }}
                                            >
                                                Delete
                                            </button>
                                        </li>;
                                    })
                                }
                                </ul>
                        </Col>}
                        <Col sm={6}  style={{marginBottom:'-50px'}}><UploadFiles onUpload={this.uploadImage.bind(this)} /></Col>
                        </FormGroup>
                        <FormGroup className="row" as={Row} controlId="formInlineCustomer" style={{ marginBottom: '15px' }}>
                            <Col sm={3}><Form.Label>Part No</Form.Label></Col>
                            <Col sm={3}>
                                <MasterPartNoInput
                                    value={partNo}
                                    onChange={value => this.setState({ partNo: value })}
                                    enabled={true}
                                    onValidationChange={this.handlePartNoValidationChange}
                                    onPartDataMatch={this.handlePartDataMatch}
                                />
                            </Col>
                            <Col sm={3}><Form.Label>Part Description</Form.Label></Col>
                            <Col sm={3}><FormControl type="text" onChange={ev => { this.setState({ partDesc: ev.target.value }) }} value={partDesc} /></Col>
                        </FormGroup>
                        <FormGroup className="row" as={Row} controlId="formInlinePlanOutput" style={{ marginBottom: '15px' }}>
                            <Col sm={3}><Form.Label>Category</Form.Label></Col>
                            <Col sm={3}><FormControl type="text" onChange={ev => { this.setState({ category: ev.target.value }) }} value={category} /></Col>
                            <Col sm={3}><Form.Label>Customer Part No</Form.Label></Col>
                            <Col sm={3}><FormControl type="text" onChange={ev => { this.setState({ customerPartNo: ev.target.value }) }} value={customerPartNo} /></Col>
                        </FormGroup>
                        <FormGroup className="row" as={Row} controlId="formInlineCustomer" style={{ marginBottom: '15px' }}>
                            <Col sm={3}><Form.Label>Customer</Form.Label></Col>
                            <Col sm={3}><FormControl type="text" onChange={ev => { this.setState({ customer: ev.target.value }) }} value={customer} /></Col>
                            <Col sm={3}><Form.Label>AQL</Form.Label></Col>
                            <Col sm={3}><FormControl type="text" onChange={ev => { this.setState({ AQL: ev.target.value }) }} value={AQL} /></Col>
                        </FormGroup>
                        <FormGroup className="row" as={Row} controlId="formInlineCustomer" style={{ marginBottom: '15px' }}>
                            <Col sm={3}><Form.Label>DWG Version</Form.Label></Col>
                            <Col sm={3}><FormControl type="text" onChange={ev => { this.setState({ dwgVersion: ev.target.value }) }} value={dwgVersion} /></Col>
                            <Col sm={3}><Form.Label>Model</Form.Label></Col>
                            <Col sm={3}><FormControl type="text" onChange={ev => { this.setState({ model: ev.target.value }) }} value={model} /></Col>
                        </FormGroup>
                        
                        <FormGroup className="row" as={Row} controlId="formInlinePlanOutput" style={{ marginBottom: '15px' }}>
                            <Col sm={12}><Form.Label>Requirement:</Form.Label></Col>
                        </FormGroup>
                        <FormGroup className="row" as={Row} controlId="formInlinePlanOutput" style={{ marginBottom: '15px' }}>
                            <Col sm={12}>
                                <Paper square>
                                    <Tabs
                                        value={this.state.tabvalue}
                                        indicatorColor="primary"
                                        textColor="primary"
                                        onChange={this.handleChange.bind(this)}
                                        aria-label="disabled tabs example"
                                    >
                                        <Tab label="Inspection" />
                                        <Tab label="Test" />
                                        <Tab label="Measuring" />
                                    </Tabs>
                                </Paper>

                            </Col></FormGroup>
                        {/* inspection */}
                        {this.state.tabvalue == 0 && <FormGroup show={false} className="row" as={Row} controlId="formInlineInspectionName">
                            <Col sm={12} style={{ position: 'relative', zIndex: 1 }}>
                                <Select
                                    options={this.state.inspections}
                                    onChange={this.selectedInspectionClicked.bind(this)}
                                    classNamePrefix="select"
                                    getOptionValue={option => option.label}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 1000 })
                                    }}
                                />
                            </Col>
                            <Col sm={12}>  <MaterialReactTable
                                columns={this.state.inspectionsColumn}
                                enablePinning
                                initialState={{ columnPinning: { left: ['requirement', 'specification'] } }}
                                data={this.state.selectedInspections.filter(item=>{return item.mode!='remove'})}
                                enableTopToolbar={false}
                                enablePagination={false}
                                enableSorting={false}
                                enableColumnActions={false}
                                enableHiding={false}
                                enableEditing={true}
                                enableRowActions={true}
                                positionActionsColumn="last"
                                renderRowActions={({ row, table }) => (
                                    <div style={{ display: 'flex', gap: '0.5rem' }}>
                                        <button
                                            type="button"
                                            onClick={() => table.setEditingRow(row)}
                                            style={{ cursor: 'pointer', padding: '4px 8px', border: 'none', background: '#2196F3', color: 'white', borderRadius: '4px' }}
                                        >
                                            Edit
                                        </button>
                                        <button
                                            type="button"
                                            onClick={() => {
                                                // Find the item by requirement (unique identifier) instead of index
                                                const updatedInspections = this.state.selectedInspections.map((item) => {
                                                    if (item.requirement === row.original.requirement && 
                                                        (item.masterID === row.original.masterID || (!item.masterID && !row.original.masterID))) {
                                                        return { ...item, mode: 'remove' };
                                                    }
                                                    return item;
                                                });
                                                this.setState({ selectedInspections: updatedInspections });
                                            }}
                                            style={{ cursor: 'pointer', padding: '4px 8px', border: 'none', background: '#f44336', color: 'white', borderRadius: '4px' }}
                                        >
                                            Delete
                                        </button>
                                    </div>
                                )}
                                onEditingRowSave={({ exitEditingMode, row, values }) => {
                                    // Find the item by requirement and masterID instead of using index
                                    const updatedInspections = this.state.selectedInspections.map((item) => {
                                        if (item.requirement === row.original.requirement && 
                                            (item.masterID === row.original.masterID || (!item.masterID && !row.original.masterID))) {
                                            return { ...item, ...values };
                                        }
                                        return item;
                                    });
                                    this.setState({ selectedInspections: updatedInspections });
                                    exitEditingMode();
                                }}
                            /></Col>
                        </FormGroup>}
                        {/* test */}
                        {this.state.tabvalue == 1 && <FormGroup show={false} className="row" as={Row} controlId="formInlineTestName">
                            <Col sm={12} style={{ position: 'relative', zIndex: 1 }}>
                                <Select
                                    options={this.state.tests}
                                    onChange={this.selectedTestClicked.bind(this)}
                                    classNamePrefix="select"
                                    getOptionValue={option => option.label}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 1000 })
                                    }}
                                />
                            </Col>
                            <Col sm={12}>  <MaterialReactTable
                                columns={this.state.testColumn}
                                enablePinning
                                initialState={{ columnPinning: { left: ['requirement', 'equipment'] } }}
                                data={this.state.selectedTests.filter(item=>{return item.mode!='remove'})}
                                enableTopToolbar={false}
                                enablePagination={false}
                                enableSorting={false}
                                enableColumnActions={false}
                                enableHiding={false}
                                enableEditing={true}
                                enableRowActions={true}
                                positionActionsColumn="last"
                                renderRowActions={({ row, table }) => (
                                    <div style={{ display: 'flex', gap: '0.5rem' }}>
                                        <button
                                            type="button"
                                            onClick={() => table.setEditingRow(row)}
                                            style={{ cursor: 'pointer', padding: '4px 8px', border: 'none', background: '#2196F3', color: 'white', borderRadius: '4px' }}
                                        >
                                            Edit
                                        </button>
                                        <button
                                            type="button"
                                            onClick={() => {
                                                // Find the item by requirement (unique identifier) instead of index
                                                const updatedTests = this.state.selectedTests.map((item) => {
                                                    if (item.requirement === row.original.requirement && 
                                                        (item.masterID === row.original.masterID || (!item.masterID && !row.original.masterID))) {
                                                        return { ...item, mode: 'remove' };
                                                    }
                                                    return item;
                                                });
                                                this.setState({ selectedTests: updatedTests });
                                            }}
                                            style={{ cursor: 'pointer', padding: '4px 8px', border: 'none', background: '#f44336', color: 'white', borderRadius: '4px' }}
                                        >
                                            Delete
                                        </button>
                                    </div>
                                )}
                                onEditingRowSave={({ exitEditingMode, row, values }) => {
                                    // Find the item by requirement and masterID instead of using index
                                    const updatedTests = this.state.selectedTests.map((item) => {
                                        if (item.requirement === row.original.requirement && 
                                            (item.masterID === row.original.masterID || (!item.masterID && !row.original.masterID))) {
                                            return { ...item, ...values };
                                        }
                                        return item;
                                    });
                                    this.setState({ selectedTests: updatedTests });
                                    exitEditingMode();
                                }}
                            /></Col>
                        </FormGroup>}
                        {/* measuring */}
                        {this.state.tabvalue == 2 && <FormGroup show={false} className="row" as={Row} controlId="formInlineMeasuringName">
                            <Col sm={12}><div class="toRight"><Button variant="primary" onClick={this.addNewMeasuring.bind(this)}>+ Add
                            </Button></div></Col>
                            <Col sm={12}>  <MaterialReactTable
                                columns={this.state.measuringColumn}
                                enablePinning
                                initialState={{ columnPinning: { left: ['pointToMeasure', 'equipment'] } }}
                                data={this.state.selectedMeasurings.filter(item=>{return item.mode!='remove'})}
                                enableTopToolbar={false}
                                enablePagination={false}
                                enableSorting={false}
                                enableColumnActions={false}
                                enableHiding={false}
                                enableEditing={true}
                                enableRowActions={true}
                                positionActionsColumn="last"
                                renderRowActions={({ row, table }) => (
                                    <div style={{ display: 'flex', gap: '0.5rem' }}>
                                        <button
                                            type="button"
                                            onClick={() => table.setEditingRow(row)}
                                            style={{ cursor: 'pointer', padding: '4px 8px', border: 'none', background: '#2196F3', color: 'white', borderRadius: '4px' }}
                                        >
                                            Edit
                                        </button>
                                        <button
                                            type="button"
                                            onClick={() => {
                                                this.setState((prevState) => ({
                                                    selectedMeasurings: deleteMeasuringRow(prevState.selectedMeasurings, row.original),
                                                }));
                                            }}
                                            style={{ cursor: 'pointer', padding: '4px 8px', border: 'none', background: '#f44336', color: 'white', borderRadius: '4px' }}
                                        >
                                            Delete
                                        </button>
                                    </div>
                                )}
                                onEditingRowSave={({ exitEditingMode, row, values }) => {
                                    this.setState((prevState) => ({
                                        selectedMeasurings: updateMeasuringRow(prevState.selectedMeasurings, row.original, values),
                                    }));
                                    exitEditingMode();
                                }}
                            /></Col>
                        </FormGroup>}
                    </Form>
                    <div class="toRight">
                        <Button variant="secondary" onClick={this.handleClose.bind(this)}>
                            Cancel
                        </Button>{' '}
                        {newMode && (<Button variant="primary" onClick={this.handleSave.bind(this)} disabled={!isPartNoCreateEnabled(this.state.partNoValidationStatus) || this.state.saving}>
                            Create
                        </Button>)}{' '}

                        {!newMode && (<Button variant="primary" onClick={this.handleSave.bind(this)} disabled={!isPartNoCreateEnabled(this.state.partNoValidationStatus) || this.state.saving}>
                            Save Changes
                        </Button>)}
                    </div>
                </div>
            </div>

        );
    }
}

export { FaiMasterForm };
